import { fullyDiagnosticsSection } from './fully.js';

/**
 * @typedef {{ title: string, rows: Array<{ label: string, value: string }> }} DiagnosticSection
 * @typedef {{
 *   id: string,
 *   capabilities: Record<string, boolean>,
 *   diagnostics: () => Promise<DiagnosticSection[]>
 * }} PlatformStrategy
 */

/** @returns {PlatformStrategy} */
export function createWebStrategy() {
  return {
    id: 'web',
    capabilities: {
      serviceWorker: 'serviceWorker' in navigator,
      indexedDb: !!globalThis.indexedDB,
      persistentStorage: !!(navigator.storage && navigator.storage.persist),
    },
    async diagnostics() {
      /** @type {DiagnosticSection[]} */
      const sections = [];

      if ('serviceWorker' in navigator) {
        const reg = await navigator.serviceWorker.getRegistration();
        sections.push({
          title: 'Service Worker',
          rows: [{ label: 'Registered', value: reg ? 'yes' : 'no' }],
        });
      }

      if (navigator.storage?.estimate) {
        try {
          const est = await navigator.storage.estimate();
          sections.push({
            title: 'Storage API',
            rows: [
              { label: 'Usage', value: String(est.usage ?? '—') },
              { label: 'Quota', value: String(est.quota ?? '—') },
            ],
          });
        } catch {
          // ignore estimate errors
        }
      }

      const fully = fullyDiagnosticsSection();
      if (fully) sections.push(fully);

      return sections;
    },
  };
}
